module.exports = __webpack_public_path__ + "static/img/23de1e50-2193-4666-9105-66de2441f32a.04e5d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/23de1e50-2193-4666-9105-66de2441f32a.png
// module id = uNHG
// module chunks = 1